(function () {
    var initializing = false, fnTest = /xyz/.test(function () { xyz; }) ? /\b_super\b/ : /.*/;
    // The base Class implementation (does nothing)
    this.Class = function () { };
    // Create a new Class that inherits from this class
    Class.extend = function (prop) {
        var _super = this.prototype;
        // Instantiate a base class (but only create the instance,
        // don't run the init constructor)
        initializing = true;
        var prototype = new this();
        initializing = false;
        // Copy the properties over onto the new prototype
        for (var name in prop) {
            // Check if we're overwriting an existing function
            prototype[name] = typeof prop[name] == "function" &&
        typeof _super[name] == "function" && fnTest.test(prop[name]) ?
        (function (name, fn) {
            return function () {
                var tmp = this._super;
                // Add a new ._super() method that is the same method
                // but on the super-class
                this._super = _super[name];
                // The method only need to be bound temporarily, so we
                // remove it when we're done executing
                var ret = fn.apply(this, arguments);
                this._super = tmp;
                return ret;
            };
        })(name, prop[name]) :
        prop[name];
        }
        // The dummy class constructor
        function Class() {
            // All construction is actually done in the init method
            if (!initializing && this.init)
                this.init.apply(this, arguments);
        }
        // Populate our constructed prototype object
        Class.prototype = prototype;
        // Enforce the constructor to be what we expect
        Class.prototype.constructor = Class;
        // And make this class extendable
        Class.extend = arguments.callee;
        return Class;
    };
})();

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.public === "undefined") {
        jQuery.extend(sm.portal, { public: {} });
    }

    window.onload = function () {
        var portalFrame = jQuery('iframe.fullframe');
        var proxyUrl = portalFrame.attr('src');

        //console.log('sm.portal.public.js --> PortalFrame: %o, ProxyUrl: ' + proxyUrl, portalFrame);

        sm.portal.ui.readyPage();
    };

    function initPage(ajax) {
        // inits
        sm.portal.public.togglePopupSearch();
    } 

   

    function setFrameSize(width, height) {
        var portalFrame = jQuery('iframe.fullframe');

        if (width && height) {
            portalFrame.attr('height', height + 'px').attr('width', width + 'px');
        }
    }

    function postMessage(data) {
        console.log('sm.portal.js --> postMessage');
        windowProxy.post(data);
    }

    function showStatus(overrideBlockUI) {
        jQuery.blockUI();
        jQuery('.blockUI.blockOverlay').css('cursor', 'wait');
    }

    function hideStatus() {
        console.log('sm.portal.js --> hideStatus');
        jQuery('.blockUI.blockOverlay').css('cursor', 'default');
        self.setTimeout('jQuery.unblockUI();', 0);
    }

    function selectPopupSearchItem(that, selectedID) {
        var src = jQuery(that).closest('[data-selectedurl]');
        var editorForE = jQuery(src).data('editorforid');
        var url = jQuery(src).data('selectedurl');
        var toclose = jQuery(that).closest('.ui-dialog');
        var ajaxdata = sm.portal.utility.getParamsRaw(that);
        var targetID = that.parents('[data-target-id]').attr('data-target-id');

        ajaxdata.appendData("selectedID", selectedID);
        ajaxdata.appendData("url", url);
        
        sm.portal.public.getPortalElementById(targetID, function (data) {

            ajaxdata.appendData("path", data.element.parent.path);
            ajaxdata.appendData("personID", data.element.parent.personId);            
            ajaxdata.data["addCnt"] = data.element.portalItemcount; // maintains zero
            
            sm.portal.public.performPortalAjaxCall(ajaxdata.data, function (newData, originalData) {
                toclose.contents().remove();
                sm.portal.public.postMessage({ action: 'selectPopupSearchItem', value: newData.response, targetID: targetID });
            });
        });
    }

    function performPortalAjaxCall(data, callback) {
        var actionGID = sm.portal.utility.newGuid();

        data['action'] = 'performPortalAjaxCall';
        data['actionGID'] = actionGID
        actionQueue[actionGID] = function (dataValue) {
            if (callback) {
                console.log('sm.portal.js --> Inside performPortalAjaxCall.CallBack');
                callback(dataValue, data);
            }
        };

        sm.portal.public.postMessage(data);
    }

    function handlePortalAjaxCallReturn(data) {
        if (data.actionGID && actionQueue[data.actionGID]) {
            if (data.response && !sm.portal.utility.isValidJson(data.response)) {
                data.response = sm.portal.public.updateContentForPortalHosting(data.response);
            }

            actionQueue[data.actionGID](data);
            actionQueue[data.actionGID] = null;
        }
    }

    function handleReturnPortalElement(data) {
        if (data.actionGID && actionQueue[data.actionGID]) {
            actionQueue[data.actionGID](data);
            actionQueue[data.actionGID] = null;
        }
    }

    function openDialog(data) {

        var baseHeight = 500;
        var baseWidth = 800;
        
        console.log('sm.portal.js --> openDialog');

        var dlg = jQuery('<div data-target-id="' + data.targetID + '"></div>').appendTo('body').dialog({
            autoOpen: false,
            autoResize: true,
            dialogClass: "editPopup searchDialog dnnFormPopup",
            modal: true,
            title: data['title'],
            height: baseHeight,
            width: baseWidth
        });
        dlg.html(sm.portal.public.updateContentForPortalHosting(data['value'])).dialog('open');
        sm.portal.ui.readyPage();
    }

    function updateContentForPortalHosting(value) {
        value = value.replace(/sm.data./g, 'sm.portal.');
        value = value.replace(/sm.ui./g, 'sm.portal.');
        value = value.replace(/PopupAcceptSelected/g, 'PopupAcceptSelectedPortal');

        value = value.replace(/<span class="icon searchIcon"><\/span>/g, '');
        value = value.replace(/<span class="icon resetSearchIcon"><\/span>/g, '');
        return value;
    }

    function hideSearchArea() {
        jQuery('.searchArea').fadeOut(0, function () {
            jQuery('.searchActivation span').removeClass('open').addClass('closed');
            jQuery('.searchAreaActivation').removeClass('off');
        });
    }

    function displayError(message) {
        if (!jQuery('#ErrorWindow')[0]) {
            jQuery('<div/>', {
                id: 'ErrorWindow',
                style: "z-index:1005;padding:1em;overflow:scroll;"
            }).appendTo('body');
        }
        
        jQuery('#ErrorWindow').html(sm.portal.utility.getResourceValue('ErrorOccuredWithWebsite'));
        jQuery('#ErrorWindow').dialog({
            autoOpen: false,
            dialogClass: "editPopup errorWindow",
            autoResize: true,
            modal: true,
            width: jQuery(window).width(),
            height: jQuery(window).height(),
            title: sm.portal.utility.getResourceValue('ServerError'),
            buttons: [
                {
                    text: 'Close',
                    click: function () {
                        jQuery(this).dialog("close");
                    }
                }
            ]

        });
        jQuery('#ErrorWindow').dialog('open');
    }

    function togglePopupSearch() {
        jQuery('.searchDialog.editPopup .pane > .headerBar > span.icon').not('[data-processed="true"]').each(function () {

            var that = jQuery(this);
            var newHeight = that.closest('.ui-widget-content').height();
            console.log(newHeight);
            that.click(function (e) {
                if (that.hasClass('open')) {
                    that.parent().next().slideUp('fast');
                    that.removeClass('open').addClass('closed');
                    that.parent().parent().next().css('height', '100%');
                }
                else if (that.hasClass('closed')) {
                    that.parent().next().slideDown('fast');
                    that.removeClass('closed').addClass('open');
                }
            });
            that.attr('data-processed', true);
        });
    }

    function getPortalElementById(id, callback) {
        var actionGID = sm.portal.utility.newGuid();
        actionQueue[actionGID] = callback;
        sm.portal.public.postMessage({ action: 'getPortalElement', actionGID: actionGID, elementID: id });
    }

    var SearchHandler = Class.extend({
        init: function (that, resultDiv, options, manual, deferBinding) {
            var _that = this;
            _that.Method = jQuery.attr(that, "data-search-method");
            _that.Action = jQuery.attr(that, "data-search-action");
            _that.ResultDiv = resultDiv;
            _that.Config = {};
            _that.SearchCrit = {};
            _that.deferBinding = false;
            _that.SearchOptions = options;
            _that.ReturnTo = jQuery.attr(that, "data-search-return");

            if (deferBinding) {
                _that.deferBinding = deferBinding;
            }

            var config = _that.Config;

            config["WildCard"] = "contains";
            config["PageSize"] = 30;

            if (!manual) {
                jQuery(that).find("[data-config]").each(function () {
                    var jQuerythat = jQuery(this);
                    var attr = jQuerythat.attr("data-config");
                    config[attr] = jQuerythat.val();
                });
            }

            if (!manual) {
                jQuery(that).find("[data-search]").each(function () {
                    _that.AddControl(this);
                });
            }
        },
        copy: function (handler) {
            var _that = this;
            _that.Method = handler.Method;
            _that.Action = handler.Action;
            _that.ResultDiv = handler.ResultDiv;
            _that.Config = handler.Config;
            _that.SearchCrit = handler.SearchCrit;
            _that.deferBinding = handler.deferBinding;
            _that.SearchOptions = handler.SearchOptions;
            _that.ColumnWidths = handler.ColumnWidths;
            _that.ReturnTo = handler.ReturnTo;
        },
        Execute: function (that, pushState) {
            this.ExecuteForPopup(that, '');
        },
        ExecuteForPopup: function (that, path) {
            var convertedObject = this.ConvertToPortalObject(path)
            console.log('sm.portal.js --> Inside ExecuteForPopup');
            console.log('sm.portal.js --> Path: ' + path);
            console.log('sm.portal.js --> Converted Object: %o', convertedObject);

            sm.portal.public.performPortalAjaxCall(convertedObject, function (newData, originalData) {
                console.log('sm.portal.js --> Inside Callback function for ExecuteForPopup');
                var el = that;
                var pt = path;
                jQuery("#" + originalData.resultDiv).html('');
                jQuery("#" + originalData.resultDiv).html(newData.response);
                sm.portal.ui.readyPage();
                sm.portal.public.hideSearchArea();
            });
        },
        AddControl: function (control) {
            var $control = jQuery(control);

            var searchID = $control.attr("data-searchid");
            var searchField = $control.attr("data-search");
            var dataType = $control.attr("data-type");
            var nullable = $control.attr("data-nullable");
            var nullasnull = $control.attr("data-nullasnull");
            var searchOp = $control.attr("data-searchop");
            var id = $control[0].id;

            if (!dataType) {
                dataType = "String";
            }
            if (!nullable) {
                nullable = true;
            }
            if (!searchOp) {
                searchOp = "Wildcard";
            }

            var value = "";

            if ($control.is(":checkbox")) {
                value = control.checked.toString();
            }
            else if (dataType == "intlist") {
                value = JSON.stringify($control.val());
                if (value == "null") value = "";
            }
            else {
                value = $control.val();
            }

            var crit = {
                SearchField: searchField,
                StrValue: value,
                DataType: dataType,
                SearchOp: searchOp,
                Nullable: nullable,
                NullAsNull: nullasnull,
                clientID: id
            }

            if (searchID != undefined) {
                this.SearchCrit[searchID] = crit;
            }
            else {
                this.SearchCrit[searchField] = crit;
            }

            return this;
        },
        Add: function (searchField, type, nullable, searchOp, value) {

            var crit = {
                StrValue: value,
                DataType: type,
                SearchOp: searchOp,
                Nullable: nullable
            }

            this.SearchCrit[searchField] = crit;

            return this;
        },
        SetConfig: function (parm, value) {
            this.Config[parm] = value;

            return this;
        },
        ConfigJSON: function () {
            return JSON.stringify(this.Config);
        },
        SearchJSON: function () {
            return JSON.stringify({ Info: this.SearchCrit });
        },
        OptionsJSON: function () {
            return JSON.stringify(this.SearchOptions);
        },
        SetAction: function (action) {
            var _that = this;
            _that.Action = action
            return this;
        },
        ConvertToPortalObject: function (path) {
            return { config: this.ConfigJSON(), criteria: this.SearchJSON(), path: path, url: this.Action, type: this.Method, resultDiv: this.ResultDiv };
        }
    });

    var AjaxHelper = Class.extend({
        init: function (array, formdata, url) {
            var _that = this;
            _that.contentType = _that.getAjaxContentType5();
            _that.processData = _that.getAjaxProcessData5();
            _that.html5 = _that.isHtml5();
            _that.data = array;
            _that.formdata = formdata;
            _that.url = url;
        },
        getAjaxContentType5: function () {
            if (window.FormData !== undefined) {
                return false;
            }
            return 'application/json; charset=utf-8';
        },
        getAjaxProcessData5: function () {
            if (window.FormData !== undefined) {
                return false;
            }
            return true;
        },
        isHtml5: function () {
            if (window.FormData !== undefined) {
                return true;
            }
            return false;
        },
        getData: function () {
            if (this.html5) {
                for (var key in this.data) {
                    if (jQuery.isArray(this.data[key])) {
                        this.processArray(key, this.data[key]);
                    }
                    else {
                        this.formdata.append(key, this.data[key]);
                    }
                }
                return this.formdata;
            }
            return JSON.stringify(this.data);
        },
        updateDataPath: function (oldPath, newPath) {
            var newData = {};

            for (var key in this.data) {
                newData[key.replace(oldPath, newPath)] = this.data[key];
            }

            this.data = newData;
        },
        getJSONData: function () {
            return this.data;
        },
        processArray: function (root, array) {
            for (var i = 0; i < array.length; i = i + 1) {
                if (jQuery.isArray(array[i])) {
                    this.processArray(root + '[' + i.toString() + ']', array[i]);
                }
                else {
                    this.formdata.append(root + '[' + i.toString() + ']', array[i]);
                }
            }
        },
        appendData: function (name, value) {
            this.data[name] = value || '';
        },
        process: function (close) {
        },
        execute: function (close, afterFunc) {
            if (close) {
                // Json will be returned on success, html returned on error, so not specifying dataType
                jQuery.ajax({
                    url: this.url,
                    type: 'POST',
                    data: this.getData(),
                    contentType: this.contentType,
                    processData: this.processData,
                    success: function (data, textStatus, jqXHR) {
                        if (afterFunc) {
                            afterFunc(data);
                        }
                        if (sm.portal.utility.isValidJson(data)) {
                            if (data.redirectUrl) {
                                window.location = data.redirectUrl;
                            }
                        }
                        else {
                            sm.portal.utility.replaceDataFromAjax(data);
                        }
                    },
                    error: function (e) {
                        sm.portal.public.displayError(e.responseText);
                    }
                });
            }
            else {
                jQuery.ajax({
                    url: this.url,
                    type: 'POST',
                    dataType: 'html',
                    data: this.getData(),
                    contentType: this.contentType,
                    processData: this.processData,
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.utility.replaceDataFromAjax(data);
                        if (jQuery("[data-validation-errors]").length == 0) {
                            //sm.communication.DisplaySimpleAlert(jQuery('#saveSucceeded').val());
                            jQuery('#globalPageDirty').val('false');
                        }
                        if (afterFunc) {
                            afterFunc(data);
                        }
                    },
                    error: function (e) {
                        sm.portal.public.displayError(e.responseText);
                    }
                });
            }
            return false;
        },
        executeProcess: function () {
            jQuery.ajax({
                url: this.url,
                type: 'POST',
                dataType: 'html',
                data: this.getData(),
                contentType: this.contentType,
                processData: this.processData,
                success: function (data, textStatus, jqXHR) {
                    if (jQuery("#Errors").length == 0) {
                        sm.portal.public.readyPage();
                        jQuery('#globalPageDirty').val('false');
                    }
                },
                error: function (e) {
                    sm.portal.public.displayError(e.responseText);
                }
            });
            return false;
        },
        executeWithAction: function (action) {
            this.data.controllerAction = action;

            // Json will be returned on success, html returned on error, so not specifying dataType
            jQuery.ajax({
                url: this.url,
                type: 'POST',
                data: this.getData(),
                contentType: this.contentType,
                processData: this.processData,
                success: function (data, textStatus, jqXHR) {
                    if (sm.portal.utility.isValidJson(data)) {
                        if (data.redirectUrl) {
                            window.location = data.redirectUrl;
                        }
                    }
                    else {
                        sm.portal.utility.replaceDataFromAjax(data);
                    }
                },
                error: function (e) {
                    sm.portal.public.displayError(e.responseText);
                }
            });
            return false;
        }
    });

    // Not found used
    //function performPopupSearch(that) {

    //    console.log('sm.portal.js --> performPopupSearch');
    //    var resultDivID = jQuery(that).attr("data-result-target");
    //    if (resultDivID) {
    //        var optionsStr = jQuery(that).attr("data-options");
    //        var options = {};
    //        if (optionsStr) {
    //            options = jQuery.parseJSON(optionsStr);
    //        }
    //        else {
    //            options = undefined;
    //        }
    //        var cis = new sm.portal.SearchHandler(that.form, resultDivID, options);
    //        cis.Execute(that.form, false);
    //        return false;
    //    }
    //    return true;
    //}

    //function showPopupSearchFields() {
    //    jQuery('.editPopup .pane > .headerBar > span.icon').each(function () {
    //        var that = jQuery(this);
    //        var newHeight = that.closest('.ui-widget-content').height();

    //        that.parent().next().slideDown('fast');
    //        that.removeClass('closed').addClass('open');
    //    });
    //}

    jQuery.extend(true, sm.portal.public, {
        postMessage: postMessage,
        setFrameSize: setFrameSize,
        showStatus: showStatus,
        hideStatus: hideStatus,
        updateContentForPortalHosting: updateContentForPortalHosting,
        performPortalAjaxCall: performPortalAjaxCall,      
        hideSearchArea: hideSearchArea,
        selectPopupSearchItem: selectPopupSearchItem,
        initPage: initPage,
        getPortalElementById: getPortalElementById,
        SearchHandler: SearchHandler, 
        AjaxHelper: AjaxHelper,
        togglePopupSearch: togglePopupSearch,
        displayError: displayError
    });


})(jQuery);

/************************************************/
/* Event Hooks                                    */
/************************************************/
(function (window, undefined) {

    jQuery(document).bind('afterSMInitPage', function () {
        sm.portal.public.initPage();
    });

})(window);













